<template>
<div class="emails">
  <div class="emails__header">
    <h2>Emails <span>2 / 5</span></h2>
    <div>
      <el-button type="primary" icon="el-icon-plus">Address</el-button>
      <el-button type="primary" icon="el-icon-plus">Mailbox</el-button>
    </div>
  </div>
  <ul class="emails__list">
    <li class="emails__list--item" v-bind:key="email.index" v-for="email in emails">
      <email-item :email="email"></email-item>
    </li>
  </ul>
</div>
</template>
<script>
import EmailItem from './EmailItem';

export default {
  data: () => ({
    emails: [
      {
        index: 0,
        name: 'M123123123',
        note: 'Lorem ipsum',
        addresses: [
          'bartek@testdomain.com',
          'michael@testdomain.com',
          'max@testdomain.com',
        ],
        space: {
          available: 1024,
          used: 453,
        },
      },
      {
        index: 1,
        name: 'M34343434',
        note: 'Lorem ipsum',
        addresses: [],
        space: {
          available: 1024,
          used: 880,
        },
      },
    ],
  }),
  components: {
    'email-item': EmailItem,
  },
};
</script>
<style lang="scss">
.emails {
  position: absolute;
  top: 70px;
  right: 0;
  padding: 0 50px;
  width: calc(100% - 100px);

  &__header {
    width: 100%;
    margin: 10px 0 30px 0;
    border-bottom: 1px solid #aaaaaa;
    display: flex;
    justify-content: space-between;
    align-items: center;

      h2 {
        text-align: left;
        font-size: 24px;

        span {
          font-size: 16px;
          font-weight: 300;
        }
      }
  }

  &__list {
    list-style: none;
    padding: 0;

    &--item {
      position: relative;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Emails.vue